import React, { useEffect, useState } from "react";

import { Box, Typography } from "@mui/material";
import { AsyncContentMui } from "components/Async-content/AsyncContentMui";

interface Props {
  file_url: string;
}

export const TxtReader: React.FC<Props> = ({ file_url }) => {
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);

    fetch(file_url)
      .then((res) => {
        if (!res.ok) {
          throw new Error();
        }
        return res.text();
      })
      .then((data) => {
        setText(data);
        setLoading(false);
      })
      .catch(() => {
        setError("Something went wrong");
        setLoading(false);
      });
  }, [file_url]);

  return (
    <AsyncContentMui isLoading={loading}>
      <Box sx={{ p: 2 }}>
        {error ? (
          <Typography>{error}</Typography>
        ) : (
          <pre
            style={{
              whiteSpace: "pre-wrap",
              wordWrap: "break-word",
              fontFamily: "inherit",
              margin: 0,
              lineHeight: 1.5
            }}
          >
            {text}
          </pre>
        )}
      </Box>
    </AsyncContentMui>
  );
};
